import { render, staticRenderFns } from "./media-reviews.vue?vue&type=template&id=aff25d3c&scoped=true&"
var script = {}
import style0 from "./media-reviews.vue?vue&type=style&index=0&id=aff25d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff25d3c",
  null
  
)

export default component.exports